<template>
    <HeadingContainer heading="Payment">

        <div class="row pb3 pb4-ns">
            <div class="mt3 mt4-ns" :class="{ 'col-xs-7 col-lg-8' : !xs, 'w-100' : xs }">
                <PaymentInfoCard/>
            </div>
            <div class="mt3 mt4-ns" :class="{ 'col-xs-5 col-lg-4 flex-column' : !xs, 'w-100' : xs }">
                <PaymentReceiptCard/>
            </div>
        </div>

        <ActionBar :fixed="true" :style="{ 'height': '80px' }">
            <div class="container w-100">
                <div class="flex items-center justify-end">
                    <div>
                        <div>I have read & accept the</div>
                        <h6>transactional agreement</h6>
                    </div>
                    <router-link class="no-underline w-50 w-25-ns ml3 ml4-ns" to="/inbox">
                        <TooliabaButton >Pay ${{total}}</TooliabaButton>
                    </router-link>
                </div>
            </div>
        </ActionBar>

    </HeadingContainer>
</template>

<script>
import HeadingContainer from '@/components/layout/HeadingContainer.vue';
import PaymentInfoCard from '@/components/rent/payment/PaymentInfoCard.vue';
import PaymentReceiptCard from '@/components/rent/payment/PaymentReceiptCard.vue';
import ActionBar from '@/components/global/ActionBar.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    data() {
        return {
            total: '192.49'
        };
    },
    components: {
        HeadingContainer,
        PaymentInfoCard,
        PaymentReceiptCard,
        ActionBar,
        TooliabaButton
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>
